import React from 'react';
import { motion } from 'framer-motion';
import { Book, Zap, Calendar, AlertCircle, Wrench, Plus } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function ProductStack() {
  const bonuses = [{
    icon: <Zap className="w-6 h-6 text-neon-cyan" data-id="element-130" />,
    title: 'Guía de Recuperación del Antebrazo',
    desc: 'Elimina la fatiga y previene tendinitis para entrenar más duro.'
  }, {
    icon: <Calendar className="w-6 h-6 text-neon-cyan" data-id="element-131" />,
    title: 'Plantilla Semanal TriGrip',
    desc: 'Ejecución automática. Sabrás exactamente qué hacer cada día.'
  }, {
    icon: <AlertCircle className="w-6 h-6 text-neon-cyan" data-id="element-132" />,
    title: 'Errores que Arruinan tu Agarre',
    desc: 'Desbloqueo inmediato corrigiendo fallas técnicas comunes.'
  }, {
    icon: <Wrench className="w-6 h-6 text-neon-cyan" data-id="element-133" />,
    title: 'Selección de Accesorios',
    desc: 'Evita perder tiempo y dinero en equipo que no funciona.'
  }];
  return <section className="py-24 bg-dark-800 relative border-t border-dark-700" data-id="element-134">
      <div className="container mx-auto px-4" data-id="element-135">
        <SectionHeading title="LO QUE TE LLEVÁS HOY" subtitle="El arsenal completo para dominar tu agarre." data-id="element-136" />

        <div className="max-w-5xl mx-auto mt-16" data-id="element-137">
          {/* Product Stack Visual */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative mb-12 flex justify-center" data-id="element-138">
            <div className="absolute inset-0 bg-neon-cyan/10 blur-[100px] rounded-full pointer-events-none" data-id="element-139"></div>
            <img src="https://cdn.magicpatterns.com/uploads/9GMcWqDafx7bGqjzmTJ9Wu/ChatGPT_Image_15_abr_2026,_14_53_05.png" alt="Grip Dominante - Sistema TriGrip + 4 Bonos" className="relative z-10 max-w-full h-auto md:max-w-2xl drop-shadow-[0_0_40px_rgba(0,240,255,0.3)]" data-id="element-140" />
          </motion.div>

          {/* Main Product */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-dark-900 to-dark-800 p-8 md:p-12 rounded-3xl border-2 border-neon-cyan shadow-neon-cyan relative overflow-hidden mb-8 max-w-4xl mx-auto" data-id="element-141">
            <div className="absolute top-0 right-0 w-64 h-64 bg-neon-cyan/10 rounded-full blur-3xl" data-id="element-142"></div>

            <div className="flex flex-col md:flex-row items-center gap-8 relative z-10" data-id="element-143">
              <div className="w-32 h-40 bg-dark-900 border border-neon-cyan/50 rounded-lg flex items-center justify-center shadow-neon-cyan shrink-0 relative overflow-hidden" data-id="element-144">
                <div className="absolute inset-0 bg-gradient-to-b from-neon-cyan/20 to-transparent" data-id="element-145"></div>
                <Book className="w-16 h-16 text-neon-cyan" data-id="element-146" />
              </div>

              <div className="text-center md:text-left" data-id="element-147">
                <div className="inline-block px-3 py-1 bg-neon-cyan/10 border border-neon-cyan/30 rounded-full text-neon-cyan text-xs font-bold tracking-widest mb-4" data-id="element-148">
                  SISTEMA PRINCIPAL
                </div>
                <h3 className="text-3xl md:text-4xl font-oswald font-bold text-white mb-4" data-id="element-149">
                  GRIP DOMINANTE
                </h3>
                <p className="text-gray-300 font-inter text-lg" data-id="element-150">
                  El sistema completo paso a paso para desarrollar una fuerza de
                  agarre inquebrantable mediante los 3 pilares biomecánicos.
                </p>
              </div>
            </div>
          </motion.div>

          <div className="flex justify-center mb-8" data-id="element-151">
            <Plus className="w-12 h-12 text-neon-cyan/50" data-id="element-152" />
          </div>

          {/* Bonuses Grid */}
          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-153">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-dark-900 p-6 rounded-2xl border border-dark-700 hover:border-neon-cyan/30 transition-colors flex gap-4" data-id="element-154">
                <div className="w-12 h-12 rounded-lg bg-dark-800 border border-dark-700 flex items-center justify-center shrink-0" data-id="element-155">
                  {bonus.icon}
                </div>
                <div data-id="element-156">
                  <div className="text-neon-cyan text-xs font-bold tracking-widest mb-1" data-id="element-157">
                    BONO #{index + 1}
                  </div>
                  <h4 className="text-xl font-oswald font-bold text-white mb-2" data-id="element-158">
                    {bonus.title}
                  </h4>
                  <p className="text-gray-400 text-sm font-inter" data-id="element-159">
                    {bonus.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}